import { Hourglass } from "lucide-react";

export const IN_USE_FILTERS = [
	{
		key: "season_id",
		label: "Temporada",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar temporada",
		options: [],
	},
	{
		key: "product_id",
		label: "Producto",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar producto",
		options: [],
		multiple: true,
	},
	{
		key: "estate_parent_id",
		label: "Campo",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar campo",
		options: [],
	},
	{
		key: "business_center_id",
		label: "Centro de Costo",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar centro de costo",
		options: [],
		multiple: true,
	},
	{
		key: "operator_id",
		label: "Operador",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar operador",
		options: [],
	},
	{
		key: "type_oa_id",
		label: "Tipo OA",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar tipo OA",
		options: [],
	},
	{
		key: "oa_code",
		label: "N° OA",
		type: "text",
		value: "",
		visible: true,
		placeholder: "Ingresar N° OA",
	},
	{
		key: "type_movement_id",
		label: "Tipo de Movimiento",
		type: "select",
		value: "",
		visible: true,
		placeholder: "Seleccionar tipo de movimiento",
		options: [
			{ value: "1", label: "Aplicación" },
			{ value: "2", label: "Traspaso" },
			{ value: "3", label: "Nota de Crédito" },
			{ value: "4", label: "Robo" },
		],
	},
	{ key: "date_from", label: "Fecha Salida Desde", type: "date", value: "", visible: true, placeholder: "Fecha salida desde" },
	{ key: "date_to", label: "Fecha Salida Hasta", type: "date", value: "", visible: true, placeholder: "Fecha salida hasta" },
];

export const IN_USE_METADATA = {
	title: "Productos En Uso",
	subtitle: "Visualiza el historial de productos en uso",
	breadcrumb: "En Uso",
	icon: Hourglass,
	path: "/historiales/en_uso",
	apiType: "in_use",
};

export const IN_USE_BASE_TABLE = {
	page: 1,
	per_page: 100,
	order_by: "date",
	order_dir: "desc",
};
